import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Activity } from '@app/shared/models/activity.model';

@Component({
  selector: 'app-activity-order-list',
  templateUrl: './activity-order-list.component.html',
  styleUrls: ['./activity-order-list.component.scss']
})
export class ActivityOrderListComponent implements OnInit {
  @Input() activities: Activity[];
  @Input() isDragNDrop = true;
  @Input() isResponsive = true;

  @Output() onReorder = new EventEmitter();
  @Output() onSelect = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  onActivityReorder($event) {
    this.onReorder.emit($event);
  }

  onSelectActivity($event) {
    this.onSelect.emit($event);
  }

}
